import { useState } from 'react';
import { auditLogApi } from '../api/auditLogApi';
import type { AuditLogSearchCondition } from '../types/auditLog';

export type ExportStatus = 'idle' | 'loading' | 'success' | 'error';

/**
 * 감사 로그 엑셀 다운로드 hook
 * GET /api/eraf/audit-logs/export (ROLE_ADMIN)
 */
export function useExportAuditLog() {
  const [status, setStatus] = useState<ExportStatus>('idle');
  const [errorCode, setErrorCode] = useState<string | undefined>();

  async function doExport(params: AuditLogSearchCondition, locale: 'ko' | 'en' = 'ko') {
    setStatus('loading');
    setErrorCode(undefined);
    try {
      const blob = await auditLogApi.export(params, locale);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `audit-log-${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setStatus('success');
      setTimeout(() => setStatus('idle'), 3000);
    } catch (err) {
      const apiErr = err as { code?: string };
      setErrorCode(apiErr.code ?? 'UNKNOWN');
      setStatus('error');
    }
  }

  return { doExport, status, errorCode, isPending: status === 'loading' };
}
